import { skeletonCardBlueprint } from "@made-people/blueprint-skeleton-card/blueprint";

skeletonCardBlueprint.override({
  slots: {
    base: "bg-surface-2 rounded-md animate-pulse aspect-[5/8]",
  },
  variants: {
    size: {
      portrait: { base: "aspect-portrait" },
      wide: { base: "aspect-ultra-wide" },
    },
  },
});
